import type { ButtonProps } from "@promptlayer/ui";
import { useCallback } from "react";

import { ConfirmationModalVariant } from "@/components/ConfirmationModal";
import { useConfirm } from "@/context/confirm-context";

export function useDataTableDeleteConfirm() {
  const { confirm } = useConfirm();

  return useCallback(
    async (args: {
      message: string;
      saveButtonVariant?: ButtonProps["variant"];
      confirmText?: string;
    }) => {
      const result = await confirm?.({
        message: args.message,
        headerVariant: ConfirmationModalVariant.destructive,
        saveButtonVariant: args.saveButtonVariant,
        confirmText: args.confirmText,
        exitButtonVariant: "outline",
      });
      return Boolean(result);
    },
    [confirm],
  );
}
